import React from 'react'

const NotFound = () => {
    return <div className="PageContainer">404 Page Not Found</div>
}

export default NotFound
